import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit, ViewChild } from '@angular/core';
import { Sort, MatPaginator } from '@angular/material';
import { AVAILABLE_COLUMNS } from './history.available-columns';
import { Select, Store } from '@ngxs/store';
import { HistoryActions } from '../state/history/actions';
import { StakeholderEmail } from '../shared/model/stakeholder-email';
import { take, tap } from 'rxjs/operators';
import { EmailService } from '../shared/services/email.service';
import { Navigate } from '@ngxs/router-plugin';
import { DialogService } from '../shared/services/dialog.service';
import { combineLatest, Observable } from 'rxjs';
import { OpenConfirmActionType } from '../shared/types/confirm-dialog-close-type';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../shared/services/token.service';

export interface DialogData {
  emailstatuses: any[];
}

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @Select(state => state.stakeholderEmail) stakeholderEmail$: Observable<StakeholderEmail>;
  projectId: number = 0;

  emailstatuses: any[];

  constructor(
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private tokenService: TokenService,
    private store: Store,
    private emailService: EmailService
  ) { }

  ngOnInit() {
    combineLatest([
      this.route.params,
      this.route.queryParams
    ]).subscribe(([params, queryParams]) =>{
      if(params.token) {
        localStorage.removeItem('token');
        localStorage.setItem('token', params.token);
      }
      if (params.id) {
        this.projectId = parseInt(params.id);
        localStorage.setItem('projectId', this.projectId.toString());
      } else if (localStorage.getItem('projectId') != null) {
        this.projectId = parseInt(localStorage.getItem('projectId'));
      }
    });
  }

  openDialog(row: StakeholderEmail): void {
    this.emailService.getAuditJson(row.Id).subscribe(rows => {
      this.dialogService.openAudit(rows).afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.emailstatuses = result;
      });
    })
  }

  ngAfterViewInit() {
    if (this.paginator) {
      this.paginator.page
        .pipe(
          tap(() => {
            this.store.dispatch(new HistoryActions.GetEmailList(this.paginator.pageSize * this.paginator.pageIndex, this.paginator.pageSize, this.projectId));
          })
        )
        .subscribe();
      if(this.projectId) {
        this.store.dispatch(new HistoryActions.GetEmailList(this.paginator.pageSize * this.paginator.pageIndex, this.paginator.pageSize, this.projectId));
        this.emailService.queryEmail(0, 0, this.projectId).subscribe(a => {
          this.paginator.length = a.length;
        });
      } else {
        this.emailService.queryEmail(0, 0, 0).subscribe(a => {
          this.paginator.length = a.length;
        });
      }
    }
  }


  @Select(state => state.history.history.emails) dataSource;

  availableColumns = AVAILABLE_COLUMNS;

  @Select(state => state.history.history.displayColumns) displayColumns;

  onSortChange(evt: Sort) {
    const orderBy = evt.direction
      ? [`${evt.active} ${evt.direction.toUpperCase()}`]
      : [];

    alert('need to handle onSort event');
  }

  getEmailAudit(row: StakeholderEmail) {
    this.store.dispatch(new HistoryActions.GetEmailAudit(row.Id));
  }

  openEmail(row: StakeholderEmail): void {
    console.log('open email ->', row.Id);
    // this.store.dispatch(new Navigate([`/email/${row.Id}`]));
    this.dialogService.openConfirmEmail().afterClosed().subscribe(type => {
      const action = type as OpenConfirmActionType;
      console.warn('To Do -> Need to handle keeping the addresses')
      // update existing email using message info from history
      switch(action){
        case 'open-message-only':
          // dispatch route with params
          this.stakeholderEmail$.pipe(take(1)).subscribe(currentEmail => {
            // use the currently loaded id and set the messageId from open action
            this.store.dispatch(new Navigate([`/email/${currentEmail.Id}`], {
              messageId: row.Id
            },
            ));
          })
          break;
        case 'open-all':
          this.store.dispatch(new Navigate([`/email/${row.Id}`]));
          break;
        case 'cancel':
          // do nothing
          break;
        default:
          console.error('Unhandled dialog close type');
      }
    });
  }

  previewEmail(row: StakeholderEmail): void {
    this.store.select(state => state.history.history).pipe(take(1)).subscribe(state => {
      console.log('preview email ->', row.Id);
      const emails = state.emails as StakeholderEmail[];
      const email = emails.filter(r => r.Id === row.Id)[0];
    const config = {
      width: '900px',
      height: '96vh',
      data: email
    };
    this.dialogService.openPreviewEmail(config);
  })
  }


}
